import { useMutation, useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { toggleDialog } from "../redux/Slices/Global/globalSlice";
import { useCustomToast } from "../pages/Contexts/ToastContext";
import { handleResErrors } from "./utils";
import axiosInstance from "../config/Axios";
import { MULTI_3D_TABLE_CONFIG } from "../Constants/datatables";
import { useDataTableContext } from "../pages/Contexts/DataTableContext";

//--------------------------Get All Countries From DB--------------------------
const getAllCountries = async () => {
    const { data } = await axiosInstance.get(`/countries/database/all`);
    return data;
}

export const useGetAllCountries = () => {
    const { showToast } = useCustomToast();
    return useQuery('getAllCountries', getAllCountries, {
        onError: (error) => showToast("error", "Fetching Countries", error.response?.data?.message)
    });
}

// Prayer v1 hooks (useGetPrayerCampaigns, useCreatePrayerCampaign,
// useEnableDevicesPrayer, useGetPrayersTimes) removed — superseded by
// src/queries/prayer.js (Prayer Auto-Pause v2). Backend routes
// /company/prayer/campaigns, /campaign/prayer/campaign/create,
// /device/prayer/enable, /device/prayer are intentionally left in place;
// the Android player still reads /device/prayer for legacy locations.

//--------------------------Create 3D collection --------------------------
const create3dCollection = async (payload) => {
    const { data } = await axiosInstance.post("/media/multi-3d/create", payload);
    return data.data;
}

export const useCreate3dCollection = () => {
    const { showToast } = useCustomToast();
    const { setLazyParams } = useDataTableContext();
    const dispatch = useDispatch()

    return useMutation(create3dCollection
        , {
            onSuccess: (data) => {
                showToast('success', "Multi-media Collection", data?.msg);
                dispatch(toggleDialog("createEditCollection"));
                setLazyParams(prev => ({ ...prev, ...MULTI_3D_TABLE_CONFIG }))
            },
            onError: (error) => handleResErrors(error, showToast)

        })
}

//--------------------------Update 3D collection --------------------------
const update3dCollection = async (payload) => {
    const { data } = await axiosInstance.post(`/media/${payload?.id}/update`, payload.data);
    return data.data;
}

export const useUpdate3dCollection = () => {
    const { showToast } = useCustomToast();
    const { setLazyParams } = useDataTableContext();
    const dispatch = useDispatch()

    return useMutation(update3dCollection,
        {
            onSuccess: () => {
                showToast('success', "Multi-media Collection", "Media collection updated successfully!");
                dispatch(toggleDialog("createEditCollection"));
                setLazyParams(prev => ({ ...prev, ...MULTI_3D_TABLE_CONFIG }))
            },
            onError: (error) => handleResErrors(error, showToast)
        })
}

//--------------------------Get collection content--------------------------
const getCollectionContent = async ({ queryKey }) => {
    const [, id] = queryKey;
    const { data } = await axiosInstance.get(`/media/${id}/multi-3d`);
    return data.data;
}

export const useGetCollectionContent = (id) => {
    const { showToast } = useCustomToast();

    const { isLoading, data, isFetching, refetch } = useQuery(
        ['getCollectionContent', id],
        getCollectionContent,
        {
            enabled: !!id,
            onError: (error) => showToast("error", "Fetching Data", error.response?.data?.message)
        }
    );

    return { isLoading, data, refetch, isFetching };
}

//--------------------------Get collection content--------------------------
const assignCollectionContent = async (payload) => {
    const { data } = await axiosInstance.post(`/media/multi-3d/${payload?.id}/assign`, payload.data);
    return data.data;
}

export const useAssignCollectionContent = () => {
    const { showToast } = useCustomToast();
    const dispatch = useDispatch()

    return useMutation(assignCollectionContent,
        {
            onSuccess: (data) => {
                showToast('success', `Add Collection Content`, data?.msg);
                dispatch(toggleDialog("addCollectionContent"))
            },
            onError: (error) => handleResErrors(error, showToast)
        })
}
